module.exports = {
  API_ROOT: 'https://api.insurancebb.com'
}
